module.exports = __webpack_public_path__ + "img/tickGray.45135a41.svg";